import store from "../../store"

export default async (to, from, next) => {
  const requirePostcode = to.meta.requirePostcode
  if (requirePostcode && !store.state.quote.postcode) {
    return next("/")
  }
  next()
}
